import { DataTableEmptyCell, DataTableRow } from "@bcc/components/data-table";
import { Badge } from "@bcc/components/ui/badge";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@bcc/components/ui/tooltip";
import { useConfigState } from "@client-shared/providers/config";
import { REQUIRED_GRIND } from "@client-shared/lib/constants";
import type { PurchaseOrder } from "@shared/types";
import { CellContext } from "@tanstack/react-table";

export const OrderItemsCell = (props: CellContext<DataTableRow<PurchaseOrder>, unknown>) => {
  const [, , configUtils] = useConfigState();
  const { lineItems } = props.row.original;

  if (!lineItems || lineItems.length === 0) {
    return <DataTableEmptyCell />;
  }

  const summary = lineItems
    .map((li) =>
      [li.quantity, li.productTitle, li.grindType ? (configUtils?.findTranslatedValue("grind", li.grindType) ?? li.grindType) : undefined]
        .filter(Boolean)
        .join(" · ")
    )
    .join("\n");

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <ul className="list-none p-0 m-0 space-y-0.5 max-w-[250px]">
            {lineItems.map((li, index) => {
              const title = li.productTitle ?? li.variantTitle ?? "—";
              const isDefaultGrind = li.grindType?.toLowerCase().includes(REQUIRED_GRIND.toLowerCase());

              return (
                <li key={li.id ?? index} className="flex items-center gap-1.5 text-sm overflow-hidden">
                  <span className="truncate">
                    {li.quantity} x {title}
                  </span>
                  {li.grindType && !isDefaultGrind && (
                    <Badge variant="outline" className="shrink-0 text-xs px-1.5 py-0 font-normal">
                      {configUtils?.findTranslatedValue("grind", li.grindType) ?? li.grindType}
                    </Badge>
                  )}
                </li>
              );
            })}
          </ul>
        </TooltipTrigger>
        <TooltipContent side="bottom" className="max-w-xs">
          <p className="whitespace-pre-line text-xs">{summary}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
